import * as React from 'react';
import classnames from 'classnames';

import ActionButton from 'components/buttons/action-button/ActionButton';
import InputArray from 'components/inputs/input-array/InputArray';

import DiscoveryContentSearchLogical from './logical/DiscoveryContentSearchLogical';

import { __t, applyTranslations } from 'utils/language';
import { getPrefix } from 'utils/helper/common';
import { getUniqueSearchTerms } from '../../utils/content';

import './discovery-content-search.scss';

import type { AndOrOptions } from 'types';

type Props = {
  isFullScreen: boolean,
  searchTerms: Array<string>,
  searchTermsLogicalOperator: AndOrOptions,
  onSearch: () => void,
  onUpdateSearchTerms: (a: Array<string>) => void,
  onUpdateSearchTermsLogical: (a: AndOrOptions) => void
};

applyTranslations(require('./discovery-content-search.i18n.json'));

const msgKey = 'discovery_content_search';

class DiscoveryContentSearch extends React.PureComponent<Props> {
  static defaultProps = {
    searchTerms: []
  };

  handleSearchTermChange = (items: Array<string>): void => {
    const { onUpdateSearchTerms } = this.props;

    const updatedItems = items.map(value => (
      getPrefix(value) ? value : `#${value}`
    ));

    if (onUpdateSearchTerms) {
      onUpdateSearchTerms(updatedItems);
    }
  };

  handleSearch = (): void => {
    const { onSearch } = this.props;

    if (onSearch) {
      onSearch();
    }
  };

  renderButton(): React.ReactNode {
    const { isFullScreen } = this.props;

    const buttonClasses = classnames('discovery-content-search__button', {
      'discovery-content-search__button--is-fullscreen': isFullScreen
    });

    return (
      <div className={buttonClasses}>
        <ActionButton
          color="primary"
          style="huge"
          customSize={{ width: '100%', height: 48 }}
          onClick={this.handleSearch}
        >
          {__t(`${msgKey}.buttons.search`)}
        </ActionButton>
      </div>
    );
  }

  renderKeywords(): React.ReactNode {
    const { searchTermsLogicalOperator, onUpdateSearchTermsLogical } = this.props;

    return (
      <div className="discovery-content-search__keywords">
        <DiscoveryContentSearchLogical
          searchTermsLogicalOperator={searchTermsLogicalOperator}
          onUpdateSearchTermsLogical={onUpdateSearchTermsLogical}
        />
      </div>
    );
  }

  renderInputField(): React.ReactNode {
    const { searchTerms } = this.props;
    const uniqueSearchTerms = getUniqueSearchTerms(searchTerms);

    return (
      <div className="discovery-content-search__input">
        <InputArray
          name="discovery-content-search-input"
          placeholder={__t(`${msgKey}.placeholders.search`)}
          value={uniqueSearchTerms}
          max={20}
          size="huge"
          onChange={this.handleSearchTermChange}
        />
      </div>
    );
  }

  render(): React.ReactNode {
    return (
      <div className="discovery-content-search">
        {this.renderInputField()}
        {this.renderKeywords()}
        {this.renderButton()}
      </div>
    );
  }
}

export default DiscoveryContentSearch;
